<script lang="ts">
  export type GatKeyboardShortcutsWithTooltipProps =
    GatKeyboardShortcutsProps & {
      tooltip?: string
    }
</script>

<script setup lang="ts">
  import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger
  } from '@gat-ship/vue-components/tooltip'
  import GatKeyboardShortcuts, {
    type GatKeyboardShortcutsProps
  } from './gat-keyboard-shortcuts.vue'
  const props = defineProps<GatKeyboardShortcutsWithTooltipProps>()
</script>
<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <gat-keyboard-shortcuts v-bind="props">
          <slot
        /></gat-keyboard-shortcuts>
      </TooltipTrigger>
      <TooltipContent>
        <slot name="tooltip">
          {{ props.tooltip }}
        </slot>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
